"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cache = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
  缓存函数
*/
var Cache = /*#__PURE__*/function () {
  _createClass(Cache, null, [{
    key: "timeout",
    // 一些方便的方法
    value: function timeout(t) {
      return Date.now() + t;
    }
  }, {
    key: "nextDay",
    value: function nextDay() {
      var now = new Date();
      return +new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    } // 缓存设置

  }]);

  function Cache(namespace) {
    var storage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : localStorage;

    _classCallCheck(this, Cache);

    _defineProperty(this, "_namespace", void 0);

    _defineProperty(this, "_storage", void 0);

    this._namespace = namespace;
    this._storage = storage;
  }

  _createClass(Cache, [{
    key: "_storageKey",
    value: function _storageKey(key) {
      return [this._namespace, key].join('/');
    }
  }, {
    key: "get",
    value: function get(key) {
      try {
        var cacheItem = JSON.parse(this._storage.getItem(this._storageKey(key)) || 'null');

        if (cacheItem) {
          var value = cacheItem.value,
              expiredAt = cacheItem.expiredAt;

          if (!expiredAt || Date.now() < expiredAt) {
            return value; //
          } else {
            this.clear(key);
          }
        }
      } catch (_) {// ignore
      }

      return null;
    }
  }, {
    key: "set",
    value: function set(key, value, expiredAt) {
      this._storage.setItem(this._storageKey(key), JSON.stringify({
        value: value,
        expiredAt: expiredAt
      }));
    }
  }, {
    key: "clear",
    value: function clear(key) {
      if (key) {
        this._storage.removeItem(this._storageKey(key));
      } else {
        var needDeleted = [];

        for (var i = 0, l = this._storage.length; i < l; ++i) {
          var storageKey = this._storage.key(i);

          if (storageKey && storageKey.startsWith(this._namespace + '/')) {
            needDeleted.push(storageKey);
          }
        }

        for (var _i = 0, _needDeleted = needDeleted; _i < _needDeleted.length; _i++) {
          var _storageKey2 = _needDeleted[_i];

          this._storage.removeItem(_storageKey2);
        }
      }
    }
  }]);

  return Cache;
}();

exports.Cache = Cache;


//////////////////
// WEBPACK FOOTER
// ./~/@weike/toolkit/lib/cache/index.js
// module id = 335
// module chunks = 6